import { JSONSchema7 } from 'json-schema';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, controlState: ControlState) => {
  state.pages.forEach((page: PageState) => {
    if (page.id === controlState.pageId) {
      const pageSchema = page.schema as JSONSchema7;
      const pageProperties = pageSchema.properties as JSONSchema7Properties;

      delete pageProperties[controlState.id];
      page.controls = page.controls.filter((c) => c.id !== controlState.id);

      return;
    }
  });

  return { ...state };
};
